import React from "react";
import { useForm } from "react-hook-form";
import axiosHelper from "../../../helpers/axios-helper";
import DisabledFormElement from "../../shared/DisabledFormElement";
import NameFormElement from "../../shared/NameFormElement";
import SaveButton from "../../shared/SaveButton";
import SubContainer from "../../shared/SubContainer";
import SubHeader from "../../shared/SubHeader";

const CategorySave = (props) => {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({ defaultValues: props.category });
  const onSubmit = async (data) => {
    try {
      await axiosHelper.post("/category/save", data);
      props.changePageMode("list");
    } catch (error) {
      axiosHelper.handleError(error);
    }
  };
  if (errors) {
    console.error(errors);
  }
  return (
    <SubContainer>
      <SubHeader
        title="Save Category"
        linkTitle="Category List"
        willChangePageMode="list"
        changePageMode={props.changePageMode}
      />
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <div className="row mb-3">
          <div className="col-6">
            <NameFormElement
              register={register}
              errors={errors}
              maxLength="250"
            />
          </div>
        </div>

        <div className="row mb-3">
          <div className="col">
            <DisabledFormElement register={register} />
          </div>
        </div>

        <div className="row">
          <div className="col">
            <SaveButton isSubmitting={isSubmitting}/>
          </div>
        </div>
      </form>
    </SubContainer>
  );
};

export default CategorySave;
